<script setup lang="ts">
import { inject } from "vue"
import { storeToRefs } from "pinia"
import { ALButton, ALModal, ALAlert } from "@af-lib/vue-ui"

import { useHeaderControlsStore } from "@/components/af/HeaderControls/HeaderControls.store"

import { useHelpStore } from "@/components/af/Help/help.store"

import type { Translate } from "@/plugins/i18n/types"
import { useCookies } from "@vueuse/integrations/useCookies"

const t = inject("t") as Translate

const headerControlsStore = useHeaderControlsStore()
const { isModalOpen, isModalSubmitDisabled } = storeToRefs(headerControlsStore)

const { assessmentSlug } = storeToRefs(useHelpStore())

type Emits = {
  onNotPassed: [string]
}
const emit = defineEmits<Emits>()

const afAuthSession = useCookies().get("af-session-auth")
const sharepool = afAuthSession?.sharepool

const modalProps = {
  iconName: "fa-thin fa-universal-access",
  title: t("assessment.accessibility.skip_assessment.modal.title"),
  body: sharepool
    ? t("assessment.accessibility.skip_assessment.modal.body")
    : t("assessment.accessibility.skip_assessment.modal.body_alt"),
  cancelBtnText: t("cancel"),
  submitBtnText: sharepool
    ? t("assessment.accessibility.skip_assessment.modal.cta")
    : t("assessment.accessibility.skip_assessment.modal.cta_alt"),
}
</script>

<template>
  <ALModal
    v-model="isModalOpen"
    size="l"
    :title="modalProps.title"
    :isClosable="true"
    headerIcon="fa-thin fa-universal-access"
  >
    <template #content>
      <p class="mb-4">{{ modalProps.body }}</p>
      <p class="mb-4">
        {{
          t("assessment.accessibility.skip_assessment.modal.restart_cooldown", {
            hour: 1,
          })
        }}
      </p>
      <ALAlert
        :description="
          $t('assessment.accessibility.skip_assessment.modal.warning')
        "
        :isDismissible="false"
        type="warning"
      />
    </template>
    <template #footer>
      <ALButton
        type="tertiary"
        :label="modalProps.cancelBtnText"
        @click="isModalOpen = false"
      />
      <ALButton
        type="primary"
        :label="modalProps.submitBtnText"
        :isDisabled="isModalSubmitDisabled"
        @click="emit('onNotPassed', assessmentSlug)"
      />
    </template>
  </ALModal>
</template>
